import { Logger } from '@frontend/logger';
import { Package, PackageActionName } from '@frontend/package/types';
import { MqttBroker } from '@frontend/pub-sub';
import { useEffect, useRef } from 'react';

import { useAppSelector } from '../../redux/store';

interface UseSlotListenerProps {
    id: string;
    onPackageSlotOpened?: (pkg: Package, data: any) => void;
    onPackageSlotNotOpened?: (pkg: Package, data: any) => void;
    onPackageSlotClosed?: (pkg: Package, data: any) => void;
    onPackageSlotNotClosed?: (pkg: Package, data: any) => void;
    onPackageSlotMoved?: (pkg: Package, data: any) => void;
}

export const useSlotListener = (props: UseSlotListenerProps) => {
    const navigationState = useAppSelector((store) => store.navigation);
    const IotId = navigationState.iot?.id;
    const propsRef = useRef(props);
    propsRef.current = props;

    useEffect(() => {
        if (!IotId) return;

        const callback = (message: string, data: any) => {
            const current = propsRef.current;

            if (message === PackageActionName.PACKAGE_INFORM_IOT_SLOT_OPENED) {
                if (!data?.package) {
                    Logger.warn('Received package slot opened message without package data', data);
                    return;
                }
                current.onPackageSlotOpened?.(data.package, data);
            }
            if (message === PackageActionName.PACKAGE_INFORM_IOT_SLOT_NOT_OPENED) {
                if (!data?.package) {
                    Logger.warn('Received package slot not opened message without package data', data);
                    return;
                }
                current.onPackageSlotNotOpened?.(data.package, data);
            }
            if (message === PackageActionName.PACKAGE_INFORM_IOT_SLOT_CLOSED) {
                if (!data?.package) {
                    Logger.warn('Received package slot closed message without package data', data);
                    return;
                }
                current.onPackageSlotClosed?.(data.package, data);
            }
            if (message === PackageActionName.PACKAGE_INFORM_IOT_SLOT_NOT_CLOSED) {
                if (!data?.package) {
                    Logger.warn('Received package slot not closed message without package data', data);
                    return;
                }
                current.onPackageSlotNotClosed?.(data.package, data);
            }
            if (message === PackageActionName.PACKAGE_INFORM_IOT_SLOT_MOVED) {
                if (!data?.package) {
                    Logger.warn('Received package slot moved message without package data', data);
                    return;
                }
                current.onPackageSlotMoved?.(data.package, data);
            }
        };

        MqttBroker.getInstance().subscribe(props.id + '_SLOT_LISTENER', 'iots/' + IotId + '/iot', callback);

        return () => {
            MqttBroker.getInstance().unSubscribe(props.id + '_SLOT_LISTENER', 'iots/' + IotId + '/iot');
        };
    }, [props.id, IotId]);
};
